import type * as Types from 'app/types/graphql';

export type ProductEdgeSelectFragment = {
  node?: Types.Maybe<
    Pick<Types.Product, 'baseID' | 'title' | 'handle'> & {
      featuredImage?: Types.Maybe<Pick<Types.Media, 'src'>>;
    }
  >;
};

export type ProductSelectFragment = Pick<Types.Product, 'baseID' | 'title' | 'handle'> & {
  featuredImage?: Types.Maybe<Pick<Types.Media, 'src'>>;
};

export const ProductSelectFragmentDoc = `
    fragment ProductSelect on Product {
  baseID
  title
  handle
  featuredImage {
    src
  }
}
    `;
export const ProductEdgeSelectFragmentDoc = `
    fragment ProductEdgeSelect on ProductEdge {
  node {
    ...ProductSelect
  }
}
    `;
